<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>Offer图列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">学生姓名</label>
              <el-input clearable v-model="searchData.username" class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">意向国家/地区</label>
              <el-select
                clearable
                v-model="searchData.country"
                placeholder="请选择"
                class="jm-input280"
              >
                <el-option
                  v-for="item in this.countryDs"
                  :label="item.value"
                  :value="item.id"
                  :key="item.id" />
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">申请学校</label>
              <el-input clearable v-model="searchData.school" class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">申请结果</label>
              <el-select
                clearable
                v-model="searchData.result"
                placeholder="请选择"
                class="jm-input280"
              >
                <el-option :value="0" label="申请中" />
                <el-option :value="1" label="成功" />
                <el-option :value="2" label="失败" />
              </el-select>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="getViewList">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
          </div>
          <!--列表部分 start -->
          <template v-if="viewList.length">
            <el-row class="offerCard" v-loading="btnLoading">
              <el-col :span="5" v-for="(o, index) in viewList" :key="index">
                <el-card :body-style="{ padding: '0px' }">
                  <img :src="o.offerImage" class="image" width="100%" height="100%">
                  <div class="box">
                    <span>{{ o.schoolname }}</span>
                    <div class="bottom clearfix">
                      <time class="time">{{ o.zhuanye_name }}</time>
                      <a :href="`/frontend/student/order/${o.crm_id}`" target="_blank">
                        <el-button type="text" class="button">{{ o.custom_name || '暂无姓名' }}</el-button>
                      </a>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <!--列表部分 end-->
            <center>
              <el-pagination
                background
                @current-change="getViewList"
                :page-size="pagination.pageSize"
                :pager-count="11"
                :current-page.sync="pagination.currentPage"
                :total="pagination.total">
              </el-pagination>
            </center>
          </template>
          <el-row v-else>
            <div v-loading="btnLoading" align="center" class="empty">
              <img src="@/assets/images/icon-nolist.png" alt="">
              <br />暂无数据
            </div>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
      searchData: {
        country: '',
        result: '',
        school: '',
        username: ''
      },
      btnLoading: false,
      formData: {},
      countryDs: [],
      viewList: [],
      pagination: {
        total: 0,
        pageSize: 0,
        pageCount: 0
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
  computed: {
  },
  methods: {
    // 重置搜索
    resetFields() {
      this.searchData = {};
      this.$store.commit('updateRefresh', true);
    },
    getViewList(currentPage) {
      if (!this.searchData.country) {
        this.$message.error('请选择意向国家/地区');
        return;
      }

      this.btnLoading = true;
      this.$http._post({
        url: `/index/offer/getViewList?page=${currentPage || ''}`,
        data: { searchData: this.searchData }
      }).then(({ data }) => {
        this.viewList = data.data;
        this.pagination = {
          total: data.total,
          pageSize: data.per_page,
          currentPage: data.current_page
        };
        this.btnLoading = false;
      });
    }
  },
  mounted() {
    // this.getDatasource().then(() => {
    //   this.services = this.ds.projects;
    // });
    this.$nextTick(() => {
      this.countryDs = JSON.parse(localStorage.getItem('fib_dict_ds')).data.online.country;
    });
  }
};
</script>
<style scoped>
  .offerCard .el-col {
    margin-left:20px;margin-bottom:20px;
  }
  .offerCard .box {
    padding: 14px;
    height: 120px;
    overflow: hidden;
  }
  .offerCard .time {
    font-size: 13px;
    color: #999;
  }
  .offerCard .bottom {
    margin-top: 13px;
    line-height: 12px;
  }
  .offerCard .button {
    padding: 0;
    float: right;
  }
  .offerCard .image {
    aspect-ratio: 3/4;
    width: 100%;
    display: block;
  }
  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  .clearfix:after {
      clear: both
  }
  .empty{
    padding:40px; border:1px #eee solid; margin: auto;color:#aaa
  }
</style>

